import { App, theme } from "antd";
import * as React from "react";
import { useSelector } from "react-redux";

const AccessContext = React.createContext({});

const AccessProvider = ({ children }) => {
  const [access, setAccess] = React.useState([]);

  const recursive = React.useCallback((value) => {
    const result = [];
    value?.access?.forEach((i) => {
      if (typeof i === "object") {
        result.push(value.field);
        const list = recursive(i);
        result.push(...list);
      } else if (typeof i === "string") {
        result.push(value.field);
        result.push(i);
      } else if (typeof i === "boolean") {
        result.push(value.field);
      }
    });
    return result;
  }, []);

  const accessAvailable = React.useMemo(() => {
    let result = [];

    if (access.length > 0) {
      result = recursive({
        field: "pos",
        access: access,
      });
    }

    return result;
  }, [access, recursive]);

  const memorizeValue = React.useMemo(
    () => [access, setAccess, accessAvailable],
    [access, accessAvailable],
  );

  return (
    <AccessContext.Provider value={memorizeValue}>
      {children}
    </AccessContext.Provider>
  );
};

export const useSetAccess = () => {
  const context = React.useContext(AccessContext);
  if (!context) {
    throw new Error(`useAccess must be used within a AccessProvider`);
  }
  const [access, setAccess] = context;
  return [access, setAccess];
};

export const useAccess = (accessKeys = []) => {
  const context = React.useContext(AccessContext);

  if (!context) {
    throw new Error("useAccess must be used within AccessProvider");
  }

  const accessData = context[2];
  const { modal: toastModal } = App.useApp();
  const { useToken } = theme;
  const {
    token: { colorPrimary },
  } = useToken();
  const userType = useSelector((state) => state.shopDetails.userType);

  const hasAccess = (key) => {
    const result = {};

    key.forEach((i) => {
      if (accessData.includes(i)) {
        result[i] = () => {
          return true;
        };
      } else {
        result[i] = (isAlert = true) => {
          if (userType === "Employee") {
            if (isAlert) {
              toastModal.error({
                title: "Access Denied",
                content:
                  "You don't have access, Please contact your administrator to request the appropriate access.",
                width: 500,
                okButtonProps: {
                  type: "primary",
                  style: {
                    background: colorPrimary,
                  },
                },
              });
            }
            return false;
          }
          return true;
        };
      }
    });
    return result;
  };

  if (!context) {
    throw new Error(`useAccess must be used within a AccessProvider`);
  }
  return hasAccess(accessKeys);
};

export default AccessProvider;
